export default __webpack_public_path__ + "static/technologies-f274d75faba4b44c94f6eb4b52e00e39.png";